module.exports = "/assets/797e972ec6267c823d56594dc20d0b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GS.png
// module id = 2541
// module chunks = 0